import script from "./loader.vue?vue&type=script&setup=true&lang=js"
export * from "./loader.vue?vue&type=script&setup=true&lang=js"

import "./loader.vue?vue&type=style&index=0&id=bce45cec&lang=css"

const __exports__ = script;

export default __exports__